import React from "react";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";

const StandardHeader = ({ onAddClick }) => (
  <Box
    sx={{
      background: "#ffffff",
      color: "white",
      borderRadius: 0,
      border: "none",
      borderBottom: "1px solid #e5e7eb",
    }}
  >
    <div className="px-4">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              bgcolor: "#dbeafe",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckIcon sx={{ color: "black" }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 0.5, fontSize: "16px",color:"black" }}>
              Standard Specification
            </Typography>
            <Typography variant="body2" sx={{ color: "black" }}>
              Manage compliance standards and requirements
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          size="large"
          startIcon={<AddIcon />}
          onClick={onAddClick}
          sx={{
            bgcolor: "#2563eb",
            "&:hover": { bgcolor: "#1d4ed8" },
            borderRadius: "12px",
            px: 3,
            py: 1.5,
          }}
        >
          Add Standard
        </Button>
      </Box>
    </div>
  </Box>
);

export default StandardHeader;
